module.exports = __webpack_public_path__ + "static/media/studio-up2.9971893f.jpg";